import { baseEnvironment, C4Environment } from '@c4/core';

export const environment: C4Environment = Object.assign(baseEnvironment, {
  production: true
});



// WEBPACK FOOTER //
// ./src/environments/environment.ts